import { jsx as e } from "react/jsx-runtime";
//#region src/IconPlayerPrevious.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		...t,
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.7 4.5a.2.2 0 0 0-.2.2v14.6c0 .11.09.2.2.2h2.412a.2.2 0 0 0 .2-.2v-5.894l11.899 5.95a.2.2 0 0 0 .289-.18V4.824a.2.2 0 0 0-.29-.18l-11.897 5.95V4.7a.2.2 0 0 0-.2-.2z",
			clipRule: "evenodd"
		})
	});
}
t.displayName = "IconPlayerPrevious";
//#endregion
export { t as default };

//# sourceMappingURL=IconPlayerPrevious.js.map